var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnheartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m10,18c-0.64498,-0.572 -1.37398,-1.167 -2.14498,-1.8l-0.01,0c-2.715,-2.22 -5.792,-4.732 -7.151,-7.74197c-0.44648,-0.95828 -0.68309,-2.00088 -0.69401,-3.058c-0.00298,-1.45052 0.57878,-2.84102 1.61382,-3.85724c1.03504,-1.01621 2.43598,-1.57237 3.88619,-1.54276c1.18063,0.00186 2.33584,0.34308 3.328,0.983c0.43597,0.28296 0.83042,0.62525 1.17198,1.017c0.3435,-0.39021 0.7381,-0.7323 1.173,-1.017c0.9918,-0.64005 2.1467,-0.98129 3.327,-0.983c1.4502,-0.02961 2.8512,0.52655 3.8862,1.54276c1.0351,1.01622 1.6168,2.40672 1.6138,3.85724c-0.0102,1.05881 -0.2468,2.10319 -0.694,3.063c-1.359,3.00997 -4.435,5.52097 -7.15,7.73697l-0.01,0.008c-0.772,0.629 -1.5,1.224 -2.145,1.8l-0.001,-0.008zm-4.49998,-15.99997c-0.93149,-0.01166 -1.82993,0.34484 -2.5,0.992c-0.64561,0.63416 -1.00644,1.50304 -1.00008,2.408c0.01141,0.7705 0.18591,1.52985 0.51208,2.228c0.64151,1.2987 1.50711,2.47407 2.557,3.47197c0.991,1 2.131,1.968 3.117,2.782c0.273,0.225 0.551,0.452 0.829,0.679l0.175,0.143c0.267,0.218 0.543,0.444 0.80998,0.666l0.013,-0.012l0.006,-0.005l0.006,0l0.009,-0.007l0.005,0l0.005,0l0.018,-0.015l0.041,-0.033l0.007,-0.006l0.011,-0.008l0.006,0l0.009,-0.008l0.664,-0.545l0.174,-0.143c0.281,-0.229 0.559,-0.456 0.832,-0.681c0.986,-0.814 2.127,-1.781 3.118,-2.786c1.0501,-0.9974 1.9157,-2.17246 2.557,-3.47097c0.3321,-0.7042 0.5091,-1.4715 0.5191,-2.25c0.0041,-0.90217 -0.3566,-1.76771 -1.0001,-2.4c-0.6688,-0.65008 -1.5674,-1.00952 -2.5,-1c-1.1381,-0.00968 -2.226,0.46736 -2.99,1.311l-1.51,1.74l-1.50998,-1.74c-0.76393,-0.84364 -1.85192,-1.32068 -2.99,-1.311z",
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 5.06247,
    rx: 2.99998,
    id: "svg_2",
    cy: 10.74999,
    cx: 9.9375,
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 6.31247,
    rx: 6.99996,
    id: "svg_3",
    cy: 8.25001,
    cx: 9.6875,
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 4.62498,
    rx: 7.87496,
    id: "svg_4",
    cy: 6.43752,
    cx: 10.4375,
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 4.87497,
    rx: 4.18748,
    id: "svg_5",
    cy: 5.18752,
    cx: 5.62502,
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 3.49998,
    rx: 2.99998,
    id: "svg_6",
    cy: 4.56253,
    cx: 15.43747,
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.0625,
    id: "svg_7",
    cy: 18.93745,
    cx: 16.49997,
    fill: "#F2994A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnheartIcon);
export default __webpack_public_path__ + "static/media/unheartIcon.0d2e7a4e.svg";
export { ForwardRef as ReactComponent };